import { errorMessage } from "./errorMessage";
import { invalidPassword, checkConfirmPassword, isEmpty } from "./rules";

export const validateChangePassword = changePassword => {
  const invalid = {
    oldPassword: isEmpty(changePassword.oldPassword, "Old Password"),
    newPassword: invalidPassword(changePassword.resetPassword),
    confirmPassword: checkConfirmPassword(changePassword),
  };
  const valid =
    Object.keys(invalid).filter(el => invalid[el] && invalid[el].length > 0)
      .length === 0;
  if (valid) {
    invalid.changePasswordValid = true;
  }
  return invalid;
};

export const validateAvailabilitySchedule = availabilitySchedule => {
  const invalid = {
    scheduleValid:
      !availabilitySchedule.schedule_id &&
      availabilitySchedule.unavailable_slots.length === 0 &&
      !availabilitySchedule.notAvailableEntireDay
        ? errorMessage.scheduleInvalid
        : false,
  };
  const valid =
    Object.keys(invalid).filter(el => invalid[el] && invalid[el].length > 0)
      .length === 0;
  if (valid) {
    invalid.availabilityScheduleValid = true;
  }
  return invalid;
};

//Notes Template Validation
export const validateTemplates = templates => {
  const invalid = {
    note_name:
      templates.note_name && templates.note_name.length > 0
        ? templates.note_name.length > 40
          ? "Maximum limit is 40 characters."
          : false
        : "Note Name is required",
    // chief_complaint: isEmpty(templates.chief_complaint, "Chief Complaint"),
    // notes:
    //   templates.notes && templates.notes.length > 0
    //     ? templates.notes === "<br>"
    //       ? "Notes is required."
    //       : false
    //     : "Notes is required",
    // assessment: isEmpty(templates.assessment, "Assessment"),
    // plan: isEmpty(templates.plan, "Plan"),
  };

  const valid =
    Object.keys(invalid).filter(el => invalid[el] && invalid[el].length > 0)
      .length === 0;

  if (valid) {
    invalid.templatesValid = true;
  }
  return invalid;
};
